import React from "react";
import { Menu, Row, Col, Divider } from "antd";
import logo from "../assets/sewmoot_logo.png";
import LoginForm from "../app/Login-Form";
import { NavLink as Link, matchPath, useRouteMatch } from "react-router-dom";
import { AuthContext } from "../Auth";
import app from "../base";
import Logout from "../app/LogOut";
import MenuItem from "antd/lib/menu/MenuItem";
const { SubMenu } = Menu;

class NavBar extends React.Component {
  static contextType = AuthContext;

  state = {
    current: this.props.location,
  };

  handleClick = (e) => {
    console.log("click ", e);

    this.setState({
      current: this.props.location,
    });
  };
  render() {
    let userActivity = this.context.currentUser;
    console.log(this.context);
    return (
      <Row>
        <Col span={18}>
          <img src={logo} alt="logo" height={80} style={{ marginTop: 10 }} />
        </Col>
        <Col span={6}>
          <Menu
            onClick={this.handleClick}
            selectedKeys={[this.state.current]}
            mode="horizontal"
            style={{ backgroundColor: "thistle" }}
          >
            <Menu.Item key="home">
              <Link to="/">Home</Link>
            </Menu.Item>
            {userActivity != null ? (
              <Menu.Item key="explore">
                <Link to="/explore">Explore</Link>
              </Menu.Item>
            ) : (
              Divider
            )}
            {/* */}
            <Menu.Item key="api">Api Documentation</Menu.Item>
            <Menu.Item>
              {userActivity != null ? (
                <Logout />
              ) : (
                <Link to="/login">Login</Link>
              )}
            </Menu.Item>
            {userActivity != null ? (
              null
            ) : (
              <SubMenu title={<>Login</>} as>
                <Menu.ItemGroup title="Login">
                  <div style={{ padding: 20 }}>
                    <LoginForm />
                  </div>
                </Menu.ItemGroup>
              </SubMenu>
            )}
          </Menu>
        </Col>
      </Row>
    );
  }
}

export default NavBar;
